import { css } from '@emotion/react'

const promotion = theme => css`
  font-size: 2rem;
  font-weight: ${theme.fontWeight.medium};
  max-width: 500px;
  color: ${theme.color.primary.info};
`

const title = theme => css`
  font-size: ${theme.fontSize.x6large};
  font-weight: ${theme.fontWeight.bold};
  line-height: ${theme.lineHeight.leadingNormal};

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    font-size: ${theme.fontSize.x5large};
  }
`

export const styles = {
  promotion,
  title,
}
